import { welcomeSVG } from "utils/assets_exports/images";

const WelcomeCard = () => {
    return (
        <div
            className=" py-4  relative flex justify-center items-center"
            style={{ height: "348px" }}
        >
            <div
                className="bg-momeento-50 rounded h-full relative w-full"
                // style={{ height: "250px" }}
            >
                <div className="welcome-text w-full h-full flex flex-col gap-5 justify-center items-start relative text-white font-medium px-4 py-4">
                    <h1 className="text-2xl">Welcome, Full Name</h1>
                    <p className="text-md">
                        Welcome back, your dashboard is ready!
                    </p>
                </div>
                <div className="welcome-overlay rounded"></div>
                <img src={welcomeSVG} className="welcome-svg" alt="welcome" />
            </div>
        </div>
    );
};

export default WelcomeCard;
